module.exports = __webpack_public_path__ + "img/1C1810_352F23_2B2C1C_2B2C24-256px.c0adf8e0.png";